import {connect} from "react-redux";
import SubleagueListTable from "../Components/SubleagueListTable.jsx";
import {fetchSubleagueEntriesAction} from "../subleaguesActions";

const mapStateToProps = (state) => {
    return {
        entries: state.subleagues.list,
        columns: state.subleagues.listColumns,
        game: state.games.current,
        ownSubleagues: state.subleagues.ownSubleagues
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onEntryClick: (subleague) => dispatch(fetchSubleagueEntriesAction(subleague)),
    }
};

const RankingTableContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(SubleagueListTable);

export default RankingTableContainer